// Quadro para assinar com o dedo ou o mouse. Ao soltar o traço, devolve a imagem PNG (Blob) em onChange;
// "Limpar" devolve null. Usado no checklist da supervisão (no formulário público a página tem o seu próprio quadro).
import React, { useEffect, useRef } from "react";
import { Button, Typography } from "@material-ui/core";

const QuadroAssinatura = ({ onChange, altura = 160 }) => {
  const ref = useRef(null);
  const estado = useRef({ desenhando: false, riscou: false });

  const ajustar = () => {
    const cv = ref.current;
    if (!cv) return;
    const r = cv.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    if (!r.width) return;
    cv.width = Math.round(r.width * dpr);
    cv.height = Math.round(r.height * dpr);
    const g = cv.getContext("2d");
    g.scale(dpr, dpr);
    g.lineWidth = 2.2;
    g.lineCap = "round";
    g.lineJoin = "round";
    g.strokeStyle = "#111";
  };
  useEffect(() => { ajustar(); }, []);

  const ponto = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const inicio = (e) => {
    if (!estado.current.riscou) ajustar(); // tamanho real só depois de visível (diálogo abrindo)
    estado.current.desenhando = true;
    ref.current.setPointerCapture(e.pointerId);
    const g = ref.current.getContext("2d");
    const [x, y] = ponto(e);
    g.beginPath();
    g.moveTo(x, y);
  };
  const mover = (e) => {
    if (!estado.current.desenhando) return;
    const g = ref.current.getContext("2d");
    const [x, y] = ponto(e);
    g.lineTo(x, y);
    g.stroke();
    estado.current.riscou = true;
  };
  const soltar = () => {
    if (!estado.current.desenhando) return;
    estado.current.desenhando = false;
    if (estado.current.riscou) ref.current.toBlob((b) => onChange(b), "image/png");
  };
  const limpar = () => {
    const cv = ref.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    estado.current.riscou = false;
    onChange(null);
  };

  return (
    <div>
      <canvas ref={ref} onPointerDown={inicio} onPointerMove={mover} onPointerUp={soltar} onPointerLeave={soltar}
        style={{ display: "block", width: "100%", height: altura, border: "1px dashed #999", borderRadius: 8, background: "#fff", touchAction: "none" }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
        <Typography variant="caption" color="textSecondary">Assine com o dedo ou o mouse</Typography>
        <Button size="small" onClick={limpar}>Limpar</Button>
      </div>
    </div>
  );
};

export default QuadroAssinatura;
